// extracted by mini-css-extract-plugin
export default {"baseStyles":"WWoLYN","root":"ddf3gM"};